// extracted by mini-css-extract-plugin
export var articleContainer = "section-alternate-grid-module--article-container--415ba";
export var articles = "section-alternate-grid-module--articles--353a3";
export var articlesComment = "section-alternate-grid-module--articles-comment--87b5e";
export var articlesPurpose = "section-alternate-grid-module--articles-purpose--b7273";
export var btnPrimary = "section-alternate-grid-module--btn-primary--5d750";
export var contentDiv = "section-alternate-grid-module--contentDiv--ed6ed";
export var contentDivOne = "section-alternate-grid-module--contentDivOne--3637a";
export var content_section = "section-alternate-grid-module--content_section--ad259";
export var descContent = "section-alternate-grid-module--descContent--39567";
export var descContentOne = "section-alternate-grid-module--descContentOne--b71f0";
export var gridSection = "section-alternate-grid-module--grid-section--9a452";
export var heading = "section-alternate-grid-module--heading--8a33c";
export var iconImage = "section-alternate-grid-module--icon-image--e5709";
export var iconSize = "section-alternate-grid-module--icon-size--c1b58";
export var iconText = "section-alternate-grid-module--icon-text--a6814";
export var imgDiv = "section-alternate-grid-module--imgDiv--0da8a";
export var imgDivOne = "section-alternate-grid-module--imgDivOne--eb307";
export var imgSection = "section-alternate-grid-module--imgSection--76252";
export var left = "section-alternate-grid-module--left--c18a4";
export var mainDiv = "section-alternate-grid-module--mainDiv--fd7db";
export var mainDivOne = "section-alternate-grid-module--mainDivOne--af60e";
export var parentDiv = "section-alternate-grid-module--parentDiv--eee13";
export var purposeTitle = "section-alternate-grid-module--purpose-title--57227";
export var right = "section-alternate-grid-module--right--778b7";
export var sectionContainer = "section-alternate-grid-module--section-container--8231a";
export var sectionText = "section-alternate-grid-module--section-text--12a23";
export var wrapper = "section-alternate-grid-module--wrapper--2349b";
export var wrapperSection = "section-alternate-grid-module--wrapper-section--0091c";
export var wrapperText = "section-alternate-grid-module--wrapper-text--b80b5";